import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const borderColor = "black";
const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    borderBottomColor: "black",
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    fontSize: 9,
    // fontStyle: 'bold', error
  },
  description: {
    width: "20%",
    textAlign: "right",
    paddingRight: 8,
    borderRightColor: borderColor,
    borderRightWidth: 1,
    backgroundColor: "#cfd8dc",
  },
  total: {
    width: "80%",
    textAlign: "center",
    borderRightWidth: 1,
    backgroundColor: "#cfd8dc",
    color: "black",
  },
});
const NotesForKO = ({ invoice }) => {
  let cal = 0;
  const NotesForKO = invoice?.Notes;

  const selectedNotes = NotesForKO.find((notes) => notes.type === "CO");

  return (
    <>
      {/* {String(invoice?.Notes_For_KO).trim() !== 'NA' && String(invoice?.Notes_For_KO).trim()  !== 'N/A' && String(invoice?.Notes_For_KO).trim() !== '' &&
             String(invoice?.Notes_For_KO).trim()  !== null &&  String(invoice?.Notes_For_KO).trim()  !== ' ' &&(            )} */}
      <View style={styles.row}>
        <Text style={styles.description}>NOTES: </Text>
        <Text style={styles.total}>{selectedNotes?.description ? selectedNotes?.description : ''}</Text>
      </View>
    </>
  );
};

export default NotesForKO;
